import React from "react";
import Layout from "../common/Layout";
// import ProjectList from "../components/projects/ProjectList";
import ProjectGallery from "../components/projects/ProjectGallery";
import PageHeaderWithLoader from "../common/PageHeaderWithLoader";
// import projectsBackground from "../assets/projectsBackground.png";

const Projects = () => (
  <Layout>
    <PageHeaderWithLoader title="Projects" media={{ type: "image", src: process.env.PUBLIC_URL + "/assets/projectsBackground.webp" }} />
    {/* <ProjectList /> */}
    
    <ProjectGallery />
  </Layout>
);

export default Projects; 
